import React from 'react';
import { Confirm } from './ui';
export default Confirm;